/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
	init: (app, Plyr, gsap, Swiper) => {
		/*
		|
		| Constants
		|-----------
		*/
		const
			$body = $('body')
			;


		/*
		| 
		| Submenu
		|-----------
		*/
		if ($(window).width() > 1200) {
			$('.header-container .nav-drop', this).not('.in .nav-drop').stop(true, true).slideUp("10");
			$(".header-container .menu-item-has-children").hover(
				function () {
					$('.nav-drop', this).not('.in .nav-drop').stop(true, true).delay(50).slideDown("10");
					$(this).toggleClass('open');
				},
				function () {
					$('.nav-drop', this).not('.in .nav-drop').stop(true, true).delay(50).slideUp("10");
					$(this).toggleClass('open');
				}
			);
		}

		jQuery(document).ready(function ($) {
			$('.header-container').on('click', function () {
				$(this).toggleClass('active');
			});
		});


		/*
		| 
		| Swiper timeline
		|-----------
		*/
		if ($('.timeline-contents').length) {
			let timelineContents = new Swiper(".timeline-contents", {
				grabCursor: true,
				autoHeight: true,
				spaceBetween: 70,
				effect: 'fade',
				navigation: {
					prevEl: ".swiper-button-prev",
					nextEl: ".swiper-button-next"
				}
			});
			let timelineDates = new Swiper(".timeline-dates", {
				spaceBetween: 90,
				centeredSlides: true,
				slidesPerView: 'auto',
				slideToClickedSlide: true,

			});

			timelineContents.controller.control = timelineDates;
			timelineDates.controller.control = timelineContents;
		}

		/*
		| 
		| Swiper gallery news
		|-----------
		*/
		if ($('#flex-gallery').length) {
			let flexgallery = new Swiper(".flex-gallery", {
				slidesPerView: 1.2,
				spaceBetween: 30,
				loop: true,
				centeredSlides: true,
				breakpoints: {
					1200: {
						slidesPerView: 2.1
					},
					1400: {
						slidesPerView: 2.5
					}
				},
				navigation: {
					prevEl: ".swiper-button-prev",
					nextEl: ".swiper-button-next"
				}
			});
		}

		/*
		|
		| Modal modale
		|-----------------
		*/
		if ($(".iziModal").length) {
			$(".iziModal").iziModal({
				headerColor: "#011A24",
				transitionIn: "fade",
				bodyOverflow: true,
				closeButton: true,
			});
		}



		/*
		|
		| Menu mobile
		|-----------------
		*/
		$(document).ready(function () {
			$("#mobile-menu .menu-item-has-children .arrow").click(function () {
				$(this).toggleClass('active').siblings('.nav-drop').slideToggle();
			});
		});


		/* Scroll menu */
		let position = $(window).scrollTop();
		$(window).scroll(function () {
			var scroll = $(window).scrollTop();

			if (position > 200) {
				$('#header').addClass('active');
			} else {
				$('#header').removeClass('active');
				$('#header').removeClass('fixed');
			}


			if (position > 200) {
				if (scroll > position) {
					$('#header').addClass('fixed');
				} else {
					$('#header').removeClass('fixed');
				}
			}
			position = scroll;
		});

		/*
		|
		| Plyr
		|-----------------
		*/
		const $customPlyrVideo = jQuery('.custom-plyr-video');
		$.each($customPlyrVideo, function () {
			const $video = $(this);
			const $videoPoster = $video.find('.item-poster');
			const $videoIcon = $video.find('.item-play-icon');
			const videoId = $video.data('id');
			const type = $video.data('type');
			let player = new Plyr(`#${videoId}`);
			$(`#${videoId}`).addClass('custom-plyr-video');

			player.on("play", (event) => {
				jQuery('.item-poster').css('opacity', '0');
			});
		});

		/*
		|
		| Button anim
		|-----------------
		*/
		$(".button_su_inner").mouseenter(function (e) {
			var parentOffset = $(this).offset();

			var relX = e.pageX - parentOffset.left;
			var relY = e.pageY - parentOffset.top;
			$(this).prev(".su_button_circle").css({ "left": relX, "top": relY });
			$(this).prev(".su_button_circle").removeClass("desplode-circle");
			$(this).prev(".su_button_circle").addClass("explode-circle");

		});

		$(".button_su_inner").mouseleave(function (e) {

			var parentOffset = $(this).offset();

			var relX = e.pageX - parentOffset.left;
			var relY = e.pageY - parentOffset.top;
			$(this).prev(".su_button_circle").css({ "left": relX, "top": relY });
			$(this).prev(".su_button_circle").removeClass("explode-circle");
			$(this).prev(".su_button_circle").addClass("desplode-circle");

		});

		/*
		|
		| Anchor
		|-----------------
		*/
		$('a[href^="#"].anchor').on('click', function (event) {
			event.preventDefault();
			var hash = this.hash;
			$('html, body').animate({
				scrollTop: $(hash).offset().top
			}, 1200, function () {
				window.location.hash = hash;
			});
		});


		/*
		|
		| Chiffres
		|-----------------
		*/
		$('.key-figures').each(function () {
			const block = {
				wrapper: $(this),
				numbers: $(this).find('.number-counter'),
			};
			if (block.numbers.length) {
				block.timeline = gsap.timeline({
					scrollTrigger: {
						trigger: block.wrapper,
						start: 'top 80%'
					}
				});
				block.numbers.toArray().forEach((number) => {
					let counter = $(number);
					// console.log(counter.data('count'));
					let count = counter.data('count').toString().replace(',', '.').replace(' ', '');
					let zero = { val: 0 };
					let decimals = count.split('.')[1];
					let toFixed = decimals ? decimals.length : false;
					count = toFixed ? parseFloat(count) : parseInt(count);
					block.timeline.to(zero, {
						duration: 1.2,
						val: count,
						ease: 'power2.out',
						onUpdate: function () {
							let val = 0;
							if (toFixed) {
								let parts = zero.val.toFixed(toFixed).toString().split('.');
								parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
								val = parts.join(',')
							} else {
								val = Math.round(zero.val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
							}
							counter.text(val);
						}
					}, '-=.7');
				});
			}
		});


		if ($("#block-logos").length) {

			var logos = jQuery('.logo');
			var spots = jQuery('.logo-spot');
			var spotIndex = 0;

			spots.eq(spotIndex).addClass('active');

			setInterval(function () {
				spots.eq(spotIndex).removeClass('active');

				var randomLogos = logos.sort(function () { return 0.5 - Math.random() }).slice(0, 9);

				// Afficher les logos aléatoires dans tous les emplacements
				spots.each(function () {
					var spot = jQuery(this);
					var logo = randomLogos.eq(spot.data('spot') - 1);
					spot.html(logo.clone().fadeIn(400));
				});

				spotIndex++;
				if (spotIndex >= spots.length) {
					spotIndex = 0;
				}

				spots.eq(spotIndex).addClass('active').fadeIn(400);
			}, 2000);

		}


	}
}
